export var ImageType;
(function (ImageType) {
    ImageType[ImageType["Device"] = 1] = "Device";
    ImageType[ImageType["Person"] = 2] = "Person";
    ImageType[ImageType["DevicesGroups"] = 3] = "DevicesGroups";
})(ImageType || (ImageType = {}));
//# sourceMappingURL=IPicture.js.map